"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardInsightSubmenuHeader = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
exports.DashboardInsightSubmenuHeader = function (_a) {
    var title = _a.title, onHeaderClick = _a.onHeaderClick;
    return (react_1.default.createElement(sdk_ui_kit_1.Typography, { tagName: "h3", className: "configuration-panel-header-title clickable", onClick: onHeaderClick },
        react_1.default.createElement("i", { className: "gd-icon-navigateleft" }),
        title));
};
//# sourceMappingURL=DashboardInsightSubmenuHeader.js.map